<div class="date-picker-container" [ngClass]="{'visible' : selectedPeriod === 'user'}">
  <div class="range-container">
    <div class="date-container" [ngClass]="{ 'invalid-input': !isDateFromValid || rangeErrorFrom}">
      <nb-icon icon="calendar" pack="icomoon"></nb-icon>
      <input
        #tooltipFrom="ngbTooltip"
        ngbTooltip="{{ rangeErrorFrom ? ('view_translations.date_range_error' | translate: errorRanges) : '' }}"
        tooltipClass="my-configurations-tooltip error-tooltip"
        [autoClose]="false"
        triggers="manual"
        [imask]="{mask: '00/00/0000'}"
        placeholder="DD/MM/YYYY"
        type="text"
        [value]="fromDateInput"
        (accept)="onDateFromInput($event, tooltipFrom)"
        (blur)="onBlur('from')" />
      <div class="error-message" *ngIf="!isDateFromValid">
        <p>{{ '*' + ('view_translations.date_error_message' | translate) }}</p>
      </div>
    </div>

    <h2>-</h2>
    <div class="date-container sec" [ngClass]="{ 'invalid-input': !isDateToValid ||  rangeErrorTo}">
      <nb-icon icon="calendar" pack="icomoon"></nb-icon>
      <input
        #tooltipTo="ngbTooltip"
        ngbTooltip="{{ rangeErrorTo ? ('view_translations.date_range_error' | translate: errorRanges) : '' }}"
        tooltipClass="my-configurations-tooltip error-tooltip"
        [autoClose]="false"
        triggers="manual"
        [imask]="{mask: '00/00/0000'}"
        placeholder="DD/MM/YYYY"
        type="text"
        [value]="toDateInput"
        (accept)="onDateToInput($event, tooltipTo)"
        (blur)="onBlur('to')" />
      <div class="error-message" *ngIf="!isDateToValid">
        <p>{{ '*' + ('view_translations.date_error_message' | translate) }}</p>
      </div>
    </div>
  </div>

  <ngb-datepicker
    class="picker"
    #dp
    (dateSelect)="onDateSelection($event)"
    [displayMonths]="numberOfMonths"
    [dayTemplate]="t"
    [outsideDays]="'visible'"
    navigation="arrows"
    [maxDate]="maxDate"
    [minDate]="minDate">
  </ngb-datepicker>

  <ng-template #t let-date let-focused="focused">
    <span
      class="custom-day"
      [class.focused]="focused"
      [class.range]="isRange(date)"
      [class.startRange]="isRangeStart(date)"
      [class.endRange]="isRangeEnd(date)"
      [class.singleDay]="isRangeOneDay(date)"
      [class.faded]="isInside(date)"
      [class.dateHoverEnd]="(hoveredDate === date) && fromDate && !toDate && !isRangeStart(date)"
      [class.outsideDay]="isInsideMonth(date)"
      (mouseenter)="handleHoverOverDate(date)"
      (mouseleave)="handleHoverOverDate(null)">
      {{ date.day }}
    </span>
  </ng-template>
</div>
